export default "__VITE_ASSET__RPmLe9NQ__"